import { type Metric } from '../vessel_data'

export enum VesselMetric {
  pressure = 'pressure',
  windSpeed = 'windSpeed',
  windDirection = 'windDirection',
  airTemperature = 'airTemperature',
  seaWaterTemperature = 'seaWaterTemperature',
  speed = 'speed',
  heading = 'heading',
  depth = 'depth',
  totalFuelConsumption = 'totalFuelConsumption',
  ecoScore = 'ecoScore',
  fuelEfficiency = 'fuelEfficiency',
}

export type VesselMetricsName = keyof typeof VesselMetric

export type VesselMetrics = Record<VesselMetricsName, Metric>

export const allVesselMetricNames: VesselMetricsName[] = Object.values(VesselMetric)
